export default [{
  path: '/securityLocation',
  name: 'securityLocation',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/securityLocation/index')
}]
